import { useTranslation } from "react-i18next";
import styles from "./ProgressSpinner.module.css";
import type { ReactNode } from "react";

type Props = {
  progress: number; // 0 to 100
  title?: ReactNode;
};

export const ProgressSpinner = ({ progress, title }: Props) => {
  const radius = 10;
  const stroke = 2;
  const normalizedRadius = radius - stroke * 0.5;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  const { t } = useTranslation();

  return (
    <svg height={radius * 2} width={radius * 2} className={styles.spinner}>
      <title>{title ?? t("global.refreshing_exchange_rate")}</title>
      <circle
        stroke="#E0E0E0"
        fill="transparent"
        strokeWidth={stroke}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <circle
        stroke="#0A1F44"
        fill="transparent"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={`${circumference} ${circumference}`}
        strokeDashoffset={strokeDashoffset}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
        className={styles.progress}
      />
    </svg>
  );
};
